import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import { AWS_CONFIG } from "../config/config";

export abstract class HttpClient {
  protected readonly instance: AxiosInstance;

  expiredCallback: any;

  protected constructor(baseURL: string, expiredTokenCb: (redirect:boolean)=>void) {
    this.instance = axios.create({
      baseURL,
      timeout: 300000,
      timeoutErrorMessage: "Request time out",
    });
    this.expiredCallback = expiredTokenCb
    this.initializeRequestInterceptor();
    this.initializeResponseInterceptor();
  }

  private initializeRequestInterceptor = () => {
    this.instance.interceptors.request.use(this.handleRequest);
  };

  private initializeResponseInterceptor = () => {
    this.instance.interceptors.response.use(
      this.handleResponse,
      this.handleError
    );
  };

  // eslint-disable-next-line class-methods-use-this
  private handleRequest = async (
    config: AxiosRequestConfig
  ): Promise<AxiosRequestConfig> => {
    const token = localStorage.getItem("idToken");
    if (!config.headers) {
      config.headers = {};
    }
    config.headers.Authorization = `Bearer ${token}`;

    // ==================================================================
    // At the moment this logic doesn't work (initialization order issue)
    // ==================================================================
    // const token = await getData("idToken");

    // return {
    //   ...config,
    //   headers: {
    //     ...config.headers,
    //     authorization: `Bearer ${token}`,
    //   },
    // };
    // ==================================================================
    // ==================================================================
    return config; // TODO: remove when the code above is uncomment
  };

  // eslint-disable-next-line class-methods-use-this
  private handleResponse = (response: AxiosResponse) => response;

  // eslint-disable-next-line class-methods-use-this
  protected handleError = async (error: any) => {
    if (
      axios.isAxiosError(error) &&
      error.response?.data.message === "The incoming token has expired"
    ) {
 

      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("idToken");

      this.expiredCallback()
    }

    if (typeof error.response.data === "string") {
      throw error;
    }

    Promise.reject(error);
  };
}
